"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StructureComponentInner = void 0;
var react_1 = require("react");
var hooks_1 = require("../../hooks");
var utils_1 = require("../../utils");
exports.StructureComponentInner = function (_a) {
    var _b = _a.selection, selection = _b === void 0 ? '' : _b;
    var component = hooks_1.useComponent();
    if (!(component instanceof utils_1.NGL.StructureComponent)) {
        throw new TypeError('NGL Component loaded from given path is not a StructureComponent');
    }
    react_1.useEffect(function () {
        component.setSelection(selection);
    }, [component, selection]);
    return null;
};
//# sourceMappingURL=StructureComponentInner.js.map